

















































































































































































































import Vue from 'vue';
import LearningTools from '@/tools/learning';
import axios, { AxiosError, AxiosRequestConfig, CancelTokenSource } from 'axios';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import RoutePaths from '@/router/route_paths';
import BbTools from '@/tools/bluebird';
import UserTools from '@/tools/user';
import { AudioSubtitle, FirebaseLesson, Phrase } from '@/store/types';
import xml2js from 'xml2js';
import firebase from 'firebase';
import Base64 from 'crypto-js/enc-base64';
import Utf8 from 'crypto-js/enc-utf8';
import SubtitleGender from '@/components/ui/SubtitleGender.vue';

require('firebase/firestore');

export default Vue.extend({
  name: 'Audio',
  components: {
    'subtitle-gender': SubtitleGender,
  },
  data() {
    return {
      imageBackground: null as string | null,
      loading: true,
      loadingStatus: '',
      langIId: null as string | null,
      langLId: null as string | null,
      lessonId: null as string | null,
      completed: false,
      indeterminateProgress: false,
      loadingPercentage: 0,
      loadingSource: null as CancelTokenSource | null,
      audioPlayer: null as videojs.Player | null,
      subtitles: new Array<AudioSubtitle>(),
      soundPosition: 0,
      timeDisplay: '',
      isPlaying: false,
      currentSpeed: 1,
      speedItems: [
        { value: 2, text: '2.00 X' },
        { value: 1.5, text: '1.50 X' },
        { value: 1, text: '1.00 X' },
        { value: 0.75, text: '0.75 X' },
        { value: 0.5, text: '0.50 X' },
      ],
      bookmarkLoading: false,
      currentSubtitle: null as AudioSubtitle | null,
      currentSubtitleImage: null as AudioSubtitle | null,
      nextSubtitle: null as AudioSubtitle | null,
    };
  },
  computed: {
    smallStyle(): boolean {
      return (this.$store.getters.isLandscape && this.$vuetify.breakpoint.smAndDown)
        || this.$vuetify.breakpoint.xs;
    },
    completedButtonsVisible(): boolean {
      return this.audioPlayer !== null && this.audioPlayer.duration() !== 0
        && (this.audioPlayer.currentTime() > this.audioPlayer.duration() - 1);
    },
  },
  async mounted(): Promise<void> {
    if (this.$store.state.lesson && this.$store.state.unit && this.$store.state.level) {
      this.imageBackground = this.getRandomPostcardsImage();
      this.$store.commit('setMainLoading', false);
      await this.initLesson();
    }
  },
  methods: {
    getRandomPostcardsImage(): string | null {
      if (this.$store.state.postcardsImages.get(this.$store.state.langL.id)) {
        let imagePath = `${this.$store.getters.ipLearn}/files/postcards/${this.$store.state.langL.id}/`;
        imagePath += BbTools.getRandomInt(this.$store.state.postcardsImages
          .get(this.$store.state.langL.id));
        return `${imagePath}-hq.jpg${BbTools.APP_POSTFIX}`;
      }
      return null;
    },
    async initLesson(): Promise<void> {
      if (!this.$store.state.langL || !this.$store.state.lesson) {
        this.$store.commit('setAlertMessage', { text: this.$store.state.tr.PleaseRestart });
        return;
      }
      this.langIId = this.$store.state.langI.id;
      this.langLId = this.$store.state.langL.id;
      this.lessonId = this.$store.state.lesson.id;
      this.loadingStatus = this.$store.state.tr.AudioLoading;
      let lessonTimeStored = 0;
      const lessonStored = this.$store.state.userLessons
        .find((lesson: FirebaseLesson) => LearningTools
          .getFirebaseLessonName(this.$store, this.langLId, this.lessonId) === LearningTools
          .getFirebaseLessonName(this.$store, lesson.lang_l, lesson.lesson_id));
      if (lessonStored) {
        if (lessonStored.lang_i === this.$store.state.langI.id) {
          lessonTimeStored = lessonStored.time;
        }
        this.completed = lessonStored.completed;
        await UserTools.updateLessonRecord(this.$store,
          LearningTools.getFirebaseLessonName(this.$store));
      } else {
        await UserTools.createLessonRecord(this.$store,
          LearningTools.getFirebaseLessonName(this.$store));
        await LearningTools.loadLessons(this.$store, this.$store.state.langI,
          this.$store.state.langL, this.$store.state.level.obj_id,
          this.$store.state.unit.unit, this.$store.state.lesson.id);
      }
      this.loadLesson(lessonTimeStored);
    },

    async loadLesson(time: number): Promise<void> {
      let url = this.$store.getters.URL_AUDIO;

      if (this.$store.state.personalizedCourse || (this.$store.state.levelDaily
        && this.$store.state.level.id === LearningTools.LEVEL_DAILY_LESSONS)) {
        url = this.$store.getters.URL_AUDIO_PERSONALIZED;
      }
      const lessonParamsEncoded = LearningTools.getLessonParamsEncoded(this.$store.state.langI.id,
        this.$store.state.langL.id, this.$store.state.lesson.id);

      url += `?_=${lessonParamsEncoded}&fuid=${this.$store.state.user.uid}&v1=true`;

      this.indeterminateProgress = true;
      const cancelToken = axios.CancelToken;
      this.loadingSource = cancelToken.source();
      const config = {
        headers: {
          'Content-Type': 'audio/x-m4a',
        },
        responseType: 'arraybuffer',
        // withCredentials: true,
        cancelToken: this.loadingSource.token,
        onDownloadProgress: (progressEvent: ProgressEvent) => {
          this.indeterminateProgress = false;
          this.loadingPercentage = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
          if (this.$store.state.mainLoading && this.loadingSource) {
            this.loadingSource.cancel(BbTools.AUDIO_LOADING_CANCEL);
          }
        },
      } as AxiosRequestConfig;

      await axios.get(url, config)
        .then((response) => {
          if (this.$store.state.mainLoading) return;
          const audioFile = new Blob([response.data], {
            type: 'audio/x-m4a',
          });
          if (response.headers['x-cachevar']) {
            this.loadSubtitles(atob(response.headers['x-cachevar']));
          }
          this.audioPlayer = videojs(`audioPlayer${this.$store.state.lesson.id}`, {
            muted: false,
            autoplay: true,
            sources: [{
              type: 'audio/x-m4a',
              src: URL.createObjectURL(audioFile),
            }],
          }, () => {
            if (this.audioPlayer) {
              this.audioPlayer.volume(this.$store.state.user.globalVolume);
              this.onTimeSet(time);
            }
          });
          this.audioPlayer.on('timeupdate', this.onTimeUpdate);
          this.audioPlayer.on('playing', this.onStartPlay);
          this.audioPlayer.on('ended', this.onPlayComplete);
          this.audioPlayer.load();
          this.loading = false;
        })
        .catch((error: Error) => {
          if (error.message !== BbTools.AUDIO_LOADING_CANCEL) {
            this.$store.commit('setAlertMessage', {
              text: 'Audio loading error #1',
              error,
            });
          }
        });
    },

    loadSubtitles(token: string) {
      const subtitlesUrl = `${this.$store.getters.URL_SUBTITLES}?_t=${token}`;
      axios.get(subtitlesUrl, BbTools.bbHeaders).then((response) => {
        try {
          xml2js.parseString(response.data, (error: Error, result: any) => {
            if (result && result.BBSubtitles && result.BBSubtitles.Subtitles
              && result.BBSubtitles.Subtitles[0] && result.BBSubtitles.Subtitles[0].subtitle) {
              const subtitles: Array<AudioSubtitle> = [];
              let previousSubtitle: AudioSubtitle | null = null;
              result.BBSubtitles.Subtitles[0].subtitle.forEach((subtitle: any, index: number) => {
                if (!subtitle.text[0] || typeof subtitle.text[0] !== 'string') {
                  subtitle.text[0] = '';
                }
                const text = subtitle.text[0];
                const startTimeArr = subtitle.$.start
                  .replace(',', '.').split(':');
                const endTimeArr = subtitle.$.stop
                  .replace(',', '.').split(':');
                const startTime = Number(startTimeArr[0]) * 60 * 60
                  + Number(startTimeArr[1]) * 60 + Number(startTimeArr[2]);
                const endTime = Number(endTimeArr[0]) * 60 * 60
                  + Number(endTimeArr[1]) * 60 + Number(endTimeArr[2]);
                let endTimeImage = null;
                if (subtitle.$.image_stop && typeof subtitle.$.image_stop === 'string') {
                  const endTimeImageArr = subtitle.$.image_stop
                    .replace(',', '.').split(':');
                  endTimeImage = Number(endTimeImageArr[0]) * 60 * 60
                    + Number(endTimeImageArr[1]) * 60 + Number(endTimeImageArr[2]);
                }
                const totalDuration = endTime - startTime;
                const totalCharLength = text.length;
                let studyingPhrase = null as Phrase | null;
                if (subtitle.$.Image && typeof subtitle.$.Image === 'string') {
                  studyingPhrase = this.$store.state.phrases
                    .find((phrase: Phrase) => phrase.id === subtitle.$.Image);
                }

                const resultSubtitle = {
                  startTime: index === 0 ? startTime : subtitles[index - 1].endTime,
                  endTime: startTime + ((totalDuration * text.length) / totalCharLength),
                  text,
                } as AudioSubtitle;

                if (studyingPhrase) {
                  if (subtitle.$.image_stop && endTimeImage) {
                    resultSubtitle.endTimeImage = endTimeImage;
                  }
                  if (studyingPhrase.word) {
                    resultSubtitle.text = studyingPhrase.word;
                  }
                  if (studyingPhrase.native_word) {
                    resultSubtitle.nativeWord = studyingPhrase.native_word;
                  }
                  if (studyingPhrase.phonetic) {
                    resultSubtitle.phonetic = studyingPhrase.phonetic;
                  }
                  if (studyingPhrase.word_image) {
                    resultSubtitle.wordImage = studyingPhrase.word_image;
                  }
                  if (studyingPhrase.id) {
                    resultSubtitle.id = studyingPhrase.id;
                  }
                  if (studyingPhrase.gender) {
                    resultSubtitle.gender = studyingPhrase.gender;
                  }
                  if (studyingPhrase.definite) {
                    resultSubtitle.definite = studyingPhrase.definite;
                  }
                  if (studyingPhrase.indefinite) {
                    resultSubtitle.indefinite = studyingPhrase.indefinite;
                  }
                  if (studyingPhrase.partitive) {
                    resultSubtitle.partitive = studyingPhrase.partitive;
                  }
                }
                previousSubtitle = resultSubtitle;
                subtitles.push(resultSubtitle);
              });
              this.subtitles = subtitles;
            } else {
              this.$store.commit('setAlertMessage', {
                text: 'Subtitles error #1',
                error,
              });
            }
          });
        } catch (error) {
          this.$store.commit('setAlertMessage', {
            text: 'Subtitles error #2',
            error,
          });
        }
      }).catch((error: AxiosError) => {
        this.$store.commit('setAlertMessage', {
          text: 'Subtitles error #3',
          error,
        });
      });
    },

    onTimeUpdate() {
      if (this.$store.state.mainLoading) {
        this.onPause();
      }
      if (this.audioPlayer && this.audioPlayer.duration()) {
        this.timeDisplay = `${this.formatTime(Math.floor(this.audioPlayer.currentTime()))
        } / ${this.formatTime(Math.floor(this.audioPlayer.duration()))}`;
        this.soundPosition = (100 * this.audioPlayer.currentTime()) / this.audioPlayer.duration();
        this.currentSubtitle = null;
        this.currentSubtitleImage = null;
        this.nextSubtitle = null;
        try {
          this.subtitles.forEach((subtitle: AudioSubtitle) => {
            if (this.currentSubtitle) {
              this.nextSubtitle = subtitle;
              throw new Error();
            }
            if (subtitle.endTimeImage && this.audioPlayer!.currentTime() > subtitle.startTime
              && this.audioPlayer!.currentTime() < subtitle.endTimeImage) {
              this.currentSubtitleImage = subtitle;
            }
            if (this.audioPlayer!.currentTime() > subtitle.startTime
              && this.audioPlayer!.currentTime() < subtitle.endTime) {
              this.currentSubtitle = subtitle;
              this.audioPlayer!.playbackRate(this.currentSpeed);
              // do not break here; break after reading the next subtitle
            }
          });
        } catch (error) {
          // nothing to handle
        }
        if (this.subtitles.length > 0) {
          if (this.currentSubtitle) {
            this.audioPlayer.playbackRate(this.currentSpeed);
          } else {
            this.audioPlayer.playbackRate(1); // do not slow down in pauses
          }
        }
      }
    },

    /* eslint-disable @typescript-eslint/camelcase */
    async saveCurrentTime() {
      if (!this.loading && this.audioPlayer) {
        let lessonToMerge = null;
        if (this.audioPlayer && this.audioPlayer.duration()
          && Math.abs(this.audioPlayer.duration()
            - (this.soundPosition * this.audioPlayer.duration()) / 100) < 15) {
          if (!this.completed) {
            this.completed = true;
            lessonToMerge = {
              time: Math.floor((this.soundPosition * this.audioPlayer.duration()) / 100),
              completed: true,
              completed_at: firebase.firestore.FieldValue.serverTimestamp(),
            };
          }
        }
        if (!lessonToMerge) {
          lessonToMerge = {
            time: Math.floor((this.soundPosition * this.audioPlayer.duration()) / 100),
          };
        }

        const lessonParamsEncodedWithoutLangI = LearningTools.getFirebaseLessonName(this.$store,
          this.langLId, this.lessonId);
        await firebase.firestore().collection('users')
          .doc(this.$store.state.user.uid).collection('lessons')
          .doc(lessonParamsEncodedWithoutLangI)
          .set(lessonToMerge, { merge: true });
        const bookmarksLessonName = this.getBookmarkLessonParamsEncoded(this.langIId,
          this.langLId, this.lessonId);
        if (this.isAvailableInBookmark(bookmarksLessonName)) {
          await firebase.firestore().collection('users')
            .doc(this.$store.state.user.uid).collection('lessons')
            .doc(bookmarksLessonName)
            .set(lessonToMerge, { merge: true });
        }
        UserTools.loadUserLessons(this.$store, this.$store.state.user.uid);

        if (this.completed) {
          await LearningTools.loadLessons(this.$store);
        }
      }
    },
    /* eslint-disable @typescript-eslint/camelcase */

    onPlayComplete(): void {
      if (this.audioPlayer) {
        this.saveCurrentTime();
        this.isPlaying = false;
      }
    },

    onSliderChange(): void {
      if (this.audioPlayer && this.audioPlayer.duration()) {
        this.audioPlayer.off('timeupdate', this.onTimeUpdate);
        this.onPause();
        this.audioPlayer.one('seeked', this.onSeeked);
        this.audioPlayer.currentTime((this.soundPosition * this.audioPlayer.duration()) / 100);
      }
    },

    onTimeSet(time: number): void {
      if (this.audioPlayer) {
        this.audioPlayer.off('timeupdate', this.onTimeUpdate);
        this.onPause();
        this.audioPlayer.one('seeked', this.onSeeked);
        this.audioPlayer.currentTime(time);
        if (this.audioPlayer.duration()) {
          this.soundPosition = (time / this.audioPlayer.duration()) * 100;
        }
      }
    },

    async onSeeked() {
      if (this.audioPlayer) {
        this.audioPlayer.on('timeupdate', this.onTimeUpdate);
        this.onPlay();
      }
    },

    onStartPlay() {
      this.isPlaying = true;
    },

    onPlayPause(): void {
      if (this.isPlaying) {
        this.onPause();
      } else {
        this.onPlay();
      }
    },

    onPlay(): void {
      if (this.audioPlayer) {
        this.isPlaying = true;
        this.audioPlayer.play();
      }
    },

    onPause(): void {
      if (this.audioPlayer) {
        this.isPlaying = false;
        this.audioPlayer.pause();
      }
    },

    on10Prev(): void {
      if (this.audioPlayer) {
        this.soundPosition -= (1000 / this.audioPlayer.duration());
        this.audioPlayer.currentTime((this.soundPosition * this.audioPlayer.duration()) / 100);
      }
    },

    on10Next(): void {
      if (this.audioPlayer) {
        this.soundPosition += (1000 / this.audioPlayer.duration());
        this.audioPlayer.currentTime((this.soundPosition * this.audioPlayer.duration()) / 100);
      }
    },

    onSpeed(): void {
      if (this.audioPlayer) {
        this.audioPlayer.playbackRate(this.currentSpeed);
      }
    },

    formatTime(secs: number): string {
      const minutes = Math.floor(secs / 60) || 0;
      const seconds = (secs - minutes * 60) || 0;
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    },

    getBookmarkLessonParamsEncoded(langIId: string | null = null, langLId: string | null = null,
      lessonId: string | null = null): string {
      if (!langIId) {
        langIId = this.$store.state.langI.id;
      }
      if (!langLId) {
        langLId = this.$store.state.langL.id;
      }
      if (!lessonId) {
        lessonId = this.$store.state.lesson ? this.$store.state.lesson.id : null;
      }
      return Base64.stringify(Utf8.parse(`ilang=${langIId}&llang=${langLId}&lesson=${lessonId}&bookmark=true`));
    },

    async onBookmark(): Promise<void> {
      this.bookmarkLoading = true;
      const lessonBookmark = this.isAvailableInBookmark(this.getBookmarkLessonParamsEncoded());
      if (lessonBookmark) {
        await UserTools.deleteBookmark(this.$store, lessonBookmark);
      } else {
        const lesson = this.$store.state.userLessons
          .find((userLesson: FirebaseLesson) => userLesson.id
            === LearningTools.getFirebaseLessonName(this.$store));
        await UserTools.createBookmark(this.$store, lesson,
          this.getBookmarkLessonParamsEncoded(), this.imageBackground);
      }
      await UserTools.loadUserLessons(this.$store, this.$store.state.user.uid);
      this.bookmarkLoading = false;
    },

    isAvailableInBookmark(lessonId: string): FirebaseLesson | null | undefined {
      return this.$store.state.userLessons
        .find((firebaseLesson: FirebaseLesson) => firebaseLesson.id
          === lessonId && firebaseLesson.isBookmark);
    },

    onQuizzes(): void {
      this.$router.push(RoutePaths.QUIZZES);
    },
    onFlashcards(): void {
      this.$router.push(RoutePaths.DRILL_FLASHCARDS);
    },
    onPronunciationAnalysis(): void {
      this.$router.push(RoutePaths.DRILL_PRONUNCIATIONANALYSIS);
    },
    onVoiceComparison(): void {
      this.$router.push(RoutePaths.DRILL_VOICECOMPARISON);
    },
    onVideo(): void {
      if (this.$store.getters.isPremiumUser) {
        this.$router.push(RoutePaths.DRILL_VIDEO);
      } else {
        this.$store.commit('setMobileLinksPopup', true);
      }
    },
  },
  async beforeDestroy() {
    if (this.loadingSource) {
      this.loadingSource.cancel(BbTools.AUDIO_LOADING_CANCEL);
    }
    await this.saveCurrentTime();
    if (this.audioPlayer) {
      this.audioPlayer.off();
      this.audioPlayer.dispose();
      this.audioPlayer = null;
    }
  },
});

